// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.space-content__Spaces_2EzZB {\n  position: relative;\n}\n.image__Spaces_2u4fe {\n  min-height: 150px;\n}\n.filters__Spaces_3oa19 {\n  position: relative;\n}\n", ""]);
// Exports
exports.locals = {
	"space-content": "space-content__Spaces_2EzZB",
	"spaceContent": "space-content__Spaces_2EzZB",
	"image": "image__Spaces_2u4fe",
	"filters": "filters__Spaces_3oa19"
};
module.exports = exports;
